import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { SelectWrapper, SelectOption } from 'src/components/Form/SelectWrapper';
import useEvents from 'src/hooks/use-events';
import EventListWrapper from '../components/EventListWrapper/EventListWrapper';
import { useProjects } from 'src/features/projects';

const EventOverview: React.FC = () => {
  const [selectedProject, setSelectedProject] = useState<string>();
  const { events, isFetching } = useEvents(selectedProject);
  const { projects } = useProjects();

  const { t: tCommon } = useTranslation('common');
  const { t: tProjects } = useTranslation('projects');
  const { t: tPageTitles } = useTranslation('pageTitles');

  const projectOptions: SelectOption[] = useMemo(
    () => projects.map((project) => ({ value: project.id, text: project.name })),
    [projects],
  );

  return (
    <ContentPage title={tPageTitles('events')} hideBreadcrumbs>
      <SelectWrapper
        label={tProjects('selectProject')}
        options={[{ value: '', text: tCommon('none') }, ...projectOptions]}
        onChange={(e) => setSelectedProject(e.target.value)}
        className="width--15"
      />
      {!isFetching && <EventListWrapper events={isFetching ? [] : events} isFetching={isFetching} />}
    </ContentPage>
  );
};

export default EventOverview;
